export default __webpack_public_path__ + "94b861f52d34bab0627e20e936787b7e.png";